/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-11 18:22:11
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-18 10:01:58
 * @FilePath: /chaoyongtuan/src/views/shopManage/components/extensionDrawer/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import ColumnTypes from '@/utils/ColumnTypes';

function getColumns (){
    let arr = [
        {
            key: '',
            label: '商品信息',
            minWidth: '300',
            type: () => import('./tableCell/goodsBox.vue'),
        },
        {
            key: '',
            label: '推广状态',
            width: '120',
            type: () => import('./tableCell/promtionCell.vue'),
        },
        {
            key: 'partner_name',
            label: '招商运营',
            width: '120',
            type: ColumnTypes.TextCell
        },
        {
            key: 'promotion_end_date',
            label: '当前推广结束时间',
            width: '160',
            type: ColumnTypes.TextCell
        },
        {
            key: '',
            label: '是否可延长',
            width: '110',
            type: () => import('./tableCell/extendCell.vue'),
        },
        {
            key: '',
            label: '延长推广结束时间',
            minWidth: '180px',
            type: () => import('./tableCell/timerPicker.vue'),
        }
    ]
    return arr
}
export default getColumns;